import React from 'react';
import { useTranslation } from 'react-i18next';
import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { Box, Button, useTheme, makeStyles } from '@dxb-web-ui-framework/design-system';

type FormButtonsProps = {
  externalEffectCallbacks: {
    onExit: () => void;
  };
  externalProps?: GenericObject;
};

const useStyles = makeStyles(theme => ({
  boxButtonWrapper: {
    width: '100%',
    height: theme.spacing(6),
    maxWidth: theme.spacing(17),
    [theme.breakpoints.down('sm')]: {
      maxWidth: theme.spacing(18.5),
    },
  },
  button: {
    height: theme.spacing(6),
  },
}));

const OTPActionButtons: React.FC<FormButtonsProps> = ({ externalEffectCallbacks, externalProps }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const classes = useStyles();

  return (
    <Box mt={4} height={theme.spacing(6)} display='flex' justifyContent='space-between' alignContent='center'>
      <Box mr={2} className={classes.boxButtonWrapper}>
        {externalProps && externalProps.cancelable ? (
          <Button
            fullWidth
            color='primary'
            size='small'
            variant='outlined'
            onClick={externalEffectCallbacks.onExit}
            classes={{ root: classes.button }}>
            {t('content-composer.components.InApp2FA.InApp2FAMethods.OTP.OTPActionButtons.Cancel.Text')}
          </Button>
        ) : (
          <Button
            fullWidth
            color='primary'
            size='small'
            variant='outlined'
            onClick={externalEffectCallbacks.onExit}
            classes={{ root: classes.button }}>
            {t('content-composer.components.InApp2FA.InApp2FAMethods.OTP.OTPActionButtons.Back.Text')}
          </Button>
        )}
      </Box>
      <Box mr='auto' width='100%' className={classes.boxButtonWrapper}>
        <Button
          fullWidth
          type='submit'
          color='primary'
          size='small'
          variant='contained'
          classes={{ root: classes.button }}>
          {t('content-composer.components.InApp2FA.InApp2FAMethods.OTP.OTPActionButtons.Submit.Text')}
        </Button>
      </Box>
    </Box>
  );
};

export { OTPActionButtons };
